import { z } from 'zod';
import { PartnerNewsActionSchema, PartnerNewsAdminSchema, PartnerNewsAudienceSchema } from '../../entities/partner-news/partner-news.schema';
import { PartnerMaterialTextSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Create Partner News Request
 * POST /api/v2/admin/partner-news
 *
 * `published: true` publishes right away; otherwise the news starts as a
 * draft. Logo and image are attached afterwards through the image endpoints.
 */ export const CreatePartnerNewsRequestSchema = z.object({
    eyebrow: PartnerMaterialTextSchema.partial().optional(),
    title: PartnerMaterialTextSchema,
    body: PartnerMaterialTextSchema,
    primaryAction: PartnerNewsActionSchema.optional(),
    secondaryAction: PartnerNewsActionSchema.optional(),
    footnote: PartnerMaterialTextSchema.partial().optional(),
    pinned: z.boolean().optional(),
    /** Omitted on create means every partner. */ audience: PartnerNewsAudienceSchema.optional(),
    published: z.boolean().optional()
});
export const CreatePartnerNewsResponseSchema = z.object({
    data: PartnerNewsAdminSchema
});

//# sourceMappingURL=create-partner-news.schema.js.map